/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIInventoryMovement } from './APIInventoryMovement';
import {
    APIInventoryMovementFromJSON,
    APIInventoryMovementFromJSONTyped,
    APIInventoryMovementToJSON,
} from './APIInventoryMovement';

/**
 * 
 * @export
 * @interface APIPaginatedInventoryMovementList
 */
export interface APIPaginatedInventoryMovementList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedInventoryMovementList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedInventoryMovementList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedInventoryMovementList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIInventoryMovement>}
     * @memberof APIPaginatedInventoryMovementList
     */
    results: Array<APIInventoryMovement>;
}

/**
 * Check if a given object implements the APIPaginatedInventoryMovementList interface.
 */
export function instanceOfAPIPaginatedInventoryMovementList(value: object): value is APIPaginatedInventoryMovementList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedInventoryMovementListFromJSON(json: any): APIPaginatedInventoryMovementList {
    return APIPaginatedInventoryMovementListFromJSONTyped(json, false);
}

export function APIPaginatedInventoryMovementListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedInventoryMovementList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIInventoryMovementFromJSON)),
    };
}

export function APIPaginatedInventoryMovementListToJSON(value?: APIPaginatedInventoryMovementList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIInventoryMovementToJSON)),
    };
}

